import React, { Suspense, lazy, } from 'react';
import { connect } from 'react-redux';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
  useParams,
  // redirect
} from "react-router-dom";

import Cookies from 'js-cookie';
// import Maintenance from './pages/Maintenance';
import DirectSignin from './pages/DirectSignin';

const Signin = lazy(() => import('./pages/Signin'));
const Signup = lazy(() => import('./pages/Signup'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const News = lazy(() => import('./pages/News'));
const Regulasi = lazy(() => import('./pages/Regulasi'));
const Referensi = lazy(() => import('./pages/Referensi'));
const DetailReferensi = lazy(() => import('./pages/Referensi/detail'));
const Kutipan = lazy(() => import('./pages/Kutipan'));
const RegistrationFKUB = lazy(() => import('./pages/RegistrationFKUB'));
const FormRegistrationFKUB = lazy(() => import('./pages/RegistrationFKUB/Form'));
const FKUB = lazy(() => import('./pages/FKUB'));
const LaporanTusi = lazy(() => import('./pages/LaporanTusi'));
const FormLaporanTusi = lazy(() => import('./pages/LaporanTusi/Form'));
const RumahIbadat = lazy(() => import('./pages/RumahIbadat'));
const FormRumahIbadat = lazy(() => import('./pages/RumahIbadat/Form'));
const DuplicateKTP = lazy(() => import('./pages/RumahIbadat/DuplicateKTP'));
const ForgetPassword = lazy(() => import('./pages/ForgetPassword'));
const Profil = lazy(() => import('./pages/Profil'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Sejarah = lazy(() => import('./pages/Sejarah'));
const VisiMisi = lazy(() => import('./pages/VisiMisi'));
const Struktur = lazy(() => import('./pages/Struktur'));
const ContactUs = lazy(() => import('./pages/ContactUs'));
const Maintenance = lazy(() => import('./pages/Maintenance'));
const BeritaPusat = lazy(() => import('./pages/BeritaPusat'));
const BeritaPusatDetail = lazy(() => import('./pages/BeritaPusat/BeritaPusatDetail'));
const BeritaDaerah = lazy(() => import('./pages/BeritaDaerah'));
const BeritaDaerahDetail = lazy(() => import('./pages/BeritaDaerah/BeritaDaerahDetail'));
const Artikel = lazy(() => import('./pages/Artikel'));
const ArtikelDetail = lazy(() => import('./pages/Artikel/ArtikelDetail'));
const Opini = lazy(() => import('./pages/Opini'));
const OpiniDetail = lazy(() => import('./pages/Opini/OpiniDetail'));
const Foto = lazy(() => import('./pages/Foto'));
const Video = lazy(() => import('./pages/Video'));
const DoaIslam = lazy(() => import('./pages/DoaIslam'));
const DoaKristen = lazy(() => import('./pages/DoaKristen'));
const DoaKatolik = lazy(() => import('./pages/DoaKatolik'));
const DoaHindu = lazy(() => import('./pages/DoaHindu'));
const DoaBudha = lazy(() => import('./pages/DoaBudha'));
const DoaKhonghucu = lazy(() => import('./pages/DoaKhonghucu'));
const ResultPage = lazy(() => import('./pages/ResultPage'));


function ListRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  // useEffect(() => {
  //   if(location.pathname !== '/v2/signin'){
  //     navigate('/maintenance')
  //   }
  // }, [location.pathname]);

  return (
    <main
      style={{
        flexGrow: 1,
        backgroundColor: location.pathname === '/pwa/akun' ? '#F7F8FC' : '#ffffff',
      }}
    >
      <Suspense fallback={<></>}>
        <Routes router={{ location, navigate, params }}>
          {/* <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/v2/signin" element={<Signin />} /> */}
          <Route path="/pwa/direct-signin" element={<DirectSignin />} />
          <Route path="/pwa/privacy-policy" element={<PrivacyPolicy />} />
          {/* {
            process.env.REACT_APP_ROLLOUT_SSO === '0' && <> */}
              <Route path="/pwa/signin" element={<Signin />} />
              <Route path="/pwa/signup" element={<Signup />} />
            {/* </>
          } */}
          <Route path="/pwa/forget-password" element={<ForgetPassword />} />
          <Route path="/pwa/news" element={<News />} />
          <Route path="/pwa/referensi/:idReferensi" element={<DetailReferensi />} />
          <Route path="/pwa/referensi" element={<Referensi />} />
          <Route path="/pwa/regulasi" element={<Regulasi />} />
          <Route path="/pwa/kutipan" element={<Kutipan />} />
          <Route path="/pwa/registration-fkub/detail/:id" element={<AuthenticatedRoute><FormRegistrationFKUB /></AuthenticatedRoute>} />
          <Route path="/pwa/registration-fkub/edit/:id" element={<AuthenticatedRoute><FormRegistrationFKUB /></AuthenticatedRoute>} />
          <Route path="/pwa/registration-fkub/form" element={<AuthenticatedRoute><FormRegistrationFKUB /></AuthenticatedRoute>} />
          <Route path="/pwa/registration-fkub" element={<AuthenticatedRoute><RegistrationFKUB /></AuthenticatedRoute>} />
          <Route path="/pwa/fkub" element={<FKUB />} />
          <Route path="/pwa/laporan-tusi/detail/:id" element={<AuthenticatedRoute><FormLaporanTusi /></AuthenticatedRoute>} />
          <Route path="/pwa/laporan-tusi/edit/:id" element={<AuthenticatedRoute><FormLaporanTusi /></AuthenticatedRoute>} />
          <Route path="/pwa/laporan-tusi/form" element={<AuthenticatedRoute><FormLaporanTusi /></AuthenticatedRoute>} />
          <Route path="/pwa/laporan-tusi" element={<AuthenticatedRoute><LaporanTusi /></AuthenticatedRoute>} />
          <Route path="/pwa/rumah-ibadat/duplicate/:id" element={<AuthenticatedRoute><DuplicateKTP /></AuthenticatedRoute>} />
          <Route path="/pwa/rumah-ibadat/detail/:id" element={<AuthenticatedRoute><FormRumahIbadat /></AuthenticatedRoute>} />
          <Route path="/pwa/rumah-ibadat/edit/:id" element={<AuthenticatedRoute><FormRumahIbadat /></AuthenticatedRoute>} />
          <Route path="/pwa/rumah-ibadat/form" element={<AuthenticatedRoute><FormRumahIbadat /></AuthenticatedRoute>} />
          <Route path="/pwa/rumah-ibadat" element={<AuthenticatedRoute><RumahIbadat /></AuthenticatedRoute>} />
          <Route path="/pwa/akun" element={<AuthenticatedRoute><Profil /></AuthenticatedRoute>} />
          <Route path="/pwa/sejarah" element={<Sejarah />} />
          <Route path="/pwa/visi-misi" element={<VisiMisi />} />
          <Route path="/pwa/struktur" element={<Struktur />} />
          <Route path="/pwa/contact-us" element={<ContactUs />} />
          <Route path="/pwa/maintenance" element={<Maintenance />} />
          <Route path="/pwa/artikel" element={<Artikel />} />
          <Route path="/pwa/artikel/detail/:slug" element={<ArtikelDetail />} />
          <Route path="/pwa/berita-pusat" element={<BeritaPusat />} />
          <Route path="/pwa/berita-pusat/detail/:slug" element={<BeritaPusatDetail />} />
          <Route path="/pwa/berita-daerah" element={<BeritaDaerah />} />
          <Route path="/pwa/berita-daerah/detail/:slug" element={<BeritaDaerahDetail />} />
          <Route path="/pwa/opini" element={<Opini />} />
          <Route path="/pwa/opini/detail/:slug" element={<OpiniDetail />} />
          <Route path="/pwa/foto" element={<Foto />} />
          <Route path="/pwa/video" element={<Video />} />
          <Route path="/pwa/doa-islam" element={<DoaIslam />} />
          <Route path="/pwa/doa-kristen" element={<DoaKristen />} />
          <Route path="/pwa/doa-katolik" element={<DoaKatolik />} />
          <Route path="/pwa/doa-hindu" element={<DoaHindu />} />
          <Route path="/pwa/doa-budha" element={<DoaBudha />} />
          <Route path="/pwa/doa-khonghucu" element={<DoaKhonghucu />} />
          <Route path="/pwa/result-page" element={<ResultPage />} />

          <Route path="/pwa/" element={<Dashboard />} exact />
        </Routes>
      </Suspense >
    </main >
  );
}

function AuthenticatedRoute({ children }) {
  let token = Cookies.get('token_fkub');
  let location = useLocation();

  if (!token) {
    return <Navigate to="/pwa" state={{ from: location }} />;
  }

  return children;
}


const mapStateToProps = ({ roleId }) => {
  return {
    roleId
  };
};

export default connect(mapStateToProps)(ListRoute);
